import { createSelector } from "@reduxjs/toolkit";
import type { RootState } from "../../";

export const selectDiagnostics = (state: RootState) => state.diagnostics;

export const selectDiagnosticsStep = createSelector([selectDiagnostics], (diagnostics) => diagnostics.step);

export const selectDiagnosticsError = createSelector([selectDiagnostics], (diagnostics) => diagnostics.error);

export const selectDiagnosticsVideoTestReport = createSelector([selectDiagnostics], (diagnostics) => diagnostics.videoTestReport);

export const selectDiagnosticsAudioInputTestReport = createSelector([selectDiagnostics], (diagnostics) => diagnostics.audioInputTestReport);
